export default function replaceSpaceWithString(
  value: string,
  replaceValue: string
) {
  return value.replace(/ /g, replaceValue);
}
